import _objectSpread from "/azp/_work/6/s/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import { mapGetters, mapMutations, mapActions } from 'vuex';
import request from '@/request';
import { ElMessage } from 'element-plus';
import cacheSessionStorage from '@/store/cache/cacheSessionStorage';
import cacheInLocalStorage from '@/store/cache/cacheInLocalStorage';
import UploadHistoryDialog from '@/views/customers/customs-clearance/list/child/UploadHistoryDialog';
import ResultDialog from '@/views/customers/customs-clearance/list/child/ResultDialog';
// import Search from '@/components/HeaderSearch'

var UN_PROCESSCED = '3';
var FAIL = '0';
var INVALID = '2';
export default {
  components: {
    UploadHistoryDialog: UploadHistoryDialog,
    ResultDialog: ResultDialog
  },
  props: {
    isAdmin: {
      type: Boolean,
      default: undefined
    },
    isTranfer: {
      type: Boolean,
      default: undefined
    }
  },
  data: function data() {
    return {
      title: 'UPS Easy Clear™智能报关管理系统',
      notifyStatus: {
        // title: '',
        // message: '请您耐心等待',
        success: 0,
        fail: 0,
        customClass: 'hide-close',
        iconClass: 'el-icon-time',
        type: '',
        id: ''
      },
      isuploadFile: false,
      filterArr: [],
      apiTimer: null,
      showDrawer: false,
      unconfirmValue: 0,
      notifyVal: null,
      comeinIndex: 0,
      hasUploadShow: false,
      exceptionNum: 0,
      unit: '条',
      detailId: '',
      detailInfo: null,
      filesTotal: 0,
      isShowProfile: false
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters({
    userinfo: 'user/userinfo',
    role: 'user/role'
  })), {}, {
    isDraft: {
      get: function get() {
        if (!this.detailInfo) return false;
        if (!this.detailInfo.isFixed && !this.detailInfo.isRowData) {
          return true;
        }
        return false;
      }
    }
  }),
  watch: {
    '$root.isuploadFile': {
      deep: true,
      handler: function handler(val) {
        if (val) {
          this.open();
        }
      }
    },
    '$root.isHistory': {
      deep: true,
      handler: function handler(val) {
        if (val) {
          this.showDrawer = val;
        }
      }
    }
  },
  created: function created() {
    // console.log('userinfo:', this.userinfo)
    // console.log('HEADER=>role-created:', this.role)
    // window.gotoDetail = this.gotoDetail
  },
  beforeUnmount: function beforeUnmount() {
    if (this.apiTimer) {
      clearInterval(this.apiTimer);
    }
    this.$root.isHistory = false;
  },
  mounted: function mounted() {
    var isB = cacheInLocalStorage.get('isB');
    var isEasyClearIdLogin = cacheInLocalStorage.get('isEasyClearIdLogin');
    if (!isB && !isEasyClearIdLogin) {
      // C端 ups id登录
      this.getUpsId();
    }
    this.getUnconfirm();
  },
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapMutations({
    SET_INFO: 'user/SET_INFO'
  })), mapActions({
    GET_INFO_CUSTOMER: 'user/GET_INFO_CUSTOMER'
  })), {}, {
    getUpsId: function getUpsId() {
      var _this = this;
      // ups id登录后获取ups id
      request({
        url: '/api/v1/ups-id',
        method: 'GET'
      }).then(function (res) {
        var decodeRes = unescape(res.replace(/\\u/g, '%u'));
        cacheInLocalStorage.set('upsId', decodeRes);
        _this.saveUserInfo(decodeRes);
      });
    },
    saveUserInfo: function saveUserInfo(id) {
      var _this2 = this;
      // ups id登录后保存用户信息
      request({
        url: '/api/v1/custom-profile',
        method: 'POST',
        data: {
          isFromUps: '1',
          upsId: id
        }
      }).then(function (res) {
        _this2.GET_INFO_CUSTOMER();
      });
    },
    // open(from) {
    //   if (this.filterArr.length > 0 && from === 'api') { // 上传完成
    //     this.notifyStatus.customClass = 'show-close'
    //     this.notifyStatus.iconClass = ''
    //     this.notifyStatus.type = 'success'
    //     this.notifyStatus.title = 'success'
    //     const notifyTimer = []
    //     this.filterArr.forEach((item, index) => {
    //       notifyTimer.push(index)
    //       notifyTimer[index] = setInterval(() => {
    //         this.notifyStatus.title = item.fileOriginName
    //         this.notifyStatus.success = item.success
    //         this.notifyStatus.fail = item.fail
    //         this.notifyStatus.id = item.id
    //         this.notifyFunc(from)
    //         clearInterval(notifyTimer[index])
    //         console.log('this.filterArr header---', this.filterArr)
    //       }, 1000)
    //     })
    //   } else { // 正在上传
    //     this.notifyStatus.customClass = 'hide-close'
    //     this.notifyStatus.iconClass = 'el-icon-time'
    //     this.notifyStatus.type = ''
    //     this.notifyStatus.title = cacheSessionStorage.get('fileName')
    //     this.notifyFunc(from)
    //     this.apiTimerFunc()
    //   }
    // },
    // notifyFunc() { // from=api即为上传完成入口，反之为正在上传入口
    //   const titleTip = this.filterArr.length > 0 && from === 'api' ? '上传完成！' : '正在上传…'
    //   const message = this.filterArr.length > 0 && from === 'api' ? `<span>成功${this.notifyStatus.success}条，</span><strong>失败${this.notifyStatus.fail}条</strong><label onclick='gotoDetail()'>查看详情 ></label>` : this.notifyStatus.message
    //   this.notifyVal = this.$notify({
    //     title: '[' + this.notifyStatus.title + ']' + titleTip,
    //     dangerouslyUseHTMLString: true,
    //     message: message,
    //     customClass: this.notifyStatus.customClass,
    //     iconClass: this.notifyStatus.iconClass,
    //     type: this.notifyStatus.type,
    //     duration: 3000,
    //     onClose: this.noCloseFunc(from)
    //   })
    // },
    open: function open() {
      this.notifyStatus.customClass = 'hide-close';
      this.notifyStatus.iconClass = 'el-icon-time';
      this.notifyStatus.type = '';
      this.notifyStatus.title = cacheSessionStorage.get('fileName');
      this.notifyFunc();
      this.apiTimerFunc();
    },
    notifyFunc: function notifyFunc() {
      // from=api即为上传完成入口，反之为正在上传入口
      // const titleTip = '正在上传…'
      // const message = this.notifyStatus.message
      this.notifyVal = this.$notify({
        // title: '[' + this.notifyStatus.title + ']' + titleTip,
        dangerouslyUseHTMLString: true,
        message: "<div class='title_info'><div class='overflow_flex'>\u6B63\u5728\u4E0A\u4F20\u6587\u4EF6</div></div><span>\u8BF7\u60A8\u8010\u5FC3\u7B49\u5F85</span>",
        customClass: this.notifyStatus.customClass,
        iconClass: this.notifyStatus.iconClass,
        type: this.notifyStatus.type,
        duration: 2000,
        onClose: this.noCloseFunc()
      });
    },
    showHistory: function showHistory() {
      this.hasUploadShow = false;
      this.showDrawer = true;
    },
    noCloseFunc: function noCloseFunc() {
      this.$root.isuploadFile = false;
      // if (from === 'api') this.getUnconfirm()
    },
    hasUploadClose: function hasUploadClose() {
      this.$root.isuploadFile = false;
      this.hasUploadShow = false;
      this.exceptionNum = 0;
      // this.getUnconfirm()
      this.$root.isUpdateList = true;
    },
    gotoDetail: function gotoDetail() {
      // this.$root.isuploadFile = false
      // this.notifyVal.close()
      // 修改日志状态
      request({
        url: '/api/v1/upload/confirm/' + this.detailId,
        method: 'PUT',
        hiddenLoading: true
      }).then(function (res) {});
      // this.showDrawer = true
      if (this.detailInfo.abnormal === 0 && this.detailInfo.repeat === 0) return;
      if (this.$refs.resultDialogRef) {
        this.$refs.resultDialogRef.show(this.detailId);
      }
      this.hasUploadClose();
    },
    apiTimerFunc: function apiTimerFunc() {
      var _this3 = this;
      var fileIdList = cacheSessionStorage.get('fileIdStorage');
      // 根据id查询文件上传状态：
      // FAIL("0","失败"), SUCCESS("1","成功"), INVALID("2","无效文件"),UN_PROCESSCED("3","未处理文件")
      request({
        url: '/api/v1/upload/log/status?fileIdList=' + fileIdList,
        method: 'GET',
        hiddenLoading: true
      }).then(function (res) {
        if (!res) return;
        // 剔除失败和无效数据，resNotFail只包含成功和未处理数据
        var resNotFail = res.filter(function (item) {
          return item.status !== FAIL;
        });
        resNotFail = resNotFail.filter(function (item) {
          return item.status !== INVALID;
        });
        // 剔除未处理数据，filterArr只有成功数据
        var filterArr = resNotFail.filter(function (item) {
          return item.status !== UN_PROCESSCED;
        });
        if (filterArr.length > 0) {
          // if (filterArr.length !== 1) this.unit = '个文件'
          var failList = res.filter(function (item) {
            return item.status === FAIL;
          });
          _this3.exceptionNum = failList.length;
          // 展示上传成功弹窗
          _this3.detailId = res[0].id;
          _this3.filesTotal = res.length;
          _this3.detailInfo = res[0];
          // isFixed & isRowData 都是false为草单，isFixed为固定模板，isRowData为自定义
          if (!_this3.detailInfo.isFixed && !_this3.detailInfo.isRowData) {
            _this3.unit = '个文件';
          } else {
            _this3.unit = '条';
          }
          _this3.getUnconfirm();
          setTimeout(function () {
            _this3.hasUploadShow = true;
            _this3.$root.isUpdateList = true;
          }, 5000);
          return;
          // setTimeout(() => this.open('api'), 3000)
          // 剔除已展示过上传完成弹窗的id，下次api不再查询
          // this.filterArr.forEach((item) => {
          //   const idx = this.fileIdList.indexOf(item.id)
          //   this.fileIdList.splice(idx, idx > -1 ? 1 : 0)
          // })
        }
        // if (this.filterArr.length === resNotFail.length) {
        //   // 当所有数据都处理成功才停止调用api
        //   return
        // }
        // 尚未上传成功，继续调用api
        _this3.apiTimer = setTimeout(function () {
          _this3.apiTimerFunc();
        }, 3000);
      }).catch(function (res) {
        ElMessage({
          message: res.message,
          iconClass: 'el-icon-warning-outline',
          grouping: true
        });
      });
    },
    showDrawerFunc: function showDrawerFunc() {
      this.showDrawer = true;
    },
    logout: function logout() {
      this.$emit('showlogout', true);
    },
    modifyPsw: function modifyPsw() {
      this.$emit('modifyPsw', true);
    },
    changeShowDrawer: function changeShowDrawer(val) {
      this.showDrawer = val;
      this.$root.isHistory = false;
    },
    getUnconfirm: function getUnconfirm() {
      var _this4 = this;
      // 查看用户未确认
      request({
        url: '/api/v1/upload/query/log/un/confirm/num',
        method: 'GET',
        hiddenLoading: true
      }).then(function (data) {
        _this4.unconfirmValue = data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    drawerClosed: function drawerClosed() {
      this.$root.isHistory = false;
      this.showDrawer = false;
      this.getUnconfirm();
    },
    getTotalString: function getTotalString() {
      if (!this.detailInfo) return '本次上传0个文件；';
      if (this.detailInfo.isFixed || this.detailInfo.isRowData) {
        return "\u672C\u6B21\u4E0A\u4F20".concat(this.detailInfo.success + this.detailInfo.repeat + this.detailInfo.abnormal, "\u6761\uFF1B");
      }
      return "\u672C\u6B21\u4E0A\u4F20".concat(this.detailInfo.success + this.detailInfo.repeat + this.detailInfo.abnormal, "\u4E2A\u6587\u4EF6\uFF1B");
    }
  })
};